<div class="lesson-card" [ngClass]="{ 'card-disabled': disabled, 'card-active': !disabled }" [matTooltip]="tooltip" 
[matTooltipDisabled]="!disabled">
    <img [src]="imageData" alt="Card image" class="lesson-card-image" loading="lazy"/>
    <div class="lesson-card-content" >
      <h3 class="lesson-card-title">{{ title }}</h3>
      <div class="progress-bar-container">
        <div class="progress-bar" [style.width.%]="progress"></div>
      </div>
    </div>
  </div>
  